import React from 'react';

const MySkills = () => {
    return (
      <div className='mb-20 px-10' id='skills'>
        <div className="text-center">
          <h2 className="text-3xl mb-5">My Skills</h2>
        </div>
        <div className="grid gap-6 mt-8 mb-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          <div className="card w-96 bg-neutral text-neutral-content">
            <div className="card-body items-center text-center">
              <div className="radial-progress" style={{ "--value": 80 }}>
                75%
              </div>
              <h2 className="card-title">Web Development</h2>
            </div>
          </div>
          <div className="card w-96 bg-neutral text-neutral-content">
            <div className="card-body items-center text-center">
              <div className="radial-progress" style={{ "--value": 75 }}>
                85%
              </div>
              <h2 className="card-title">Front-End Developent</h2>
            </div>
          </div>
          <div className="card w-96 bg-neutral text-neutral-content">
            <div className="card-body items-center text-center">
              <div className="radial-progress" style={{ "--value": 60 }}>
                60%
              </div>
              <h2 className="card-title">Bakend Development</h2>
            </div>
          </div>
        </div>

        <div className="grid gap-6 mt-8 mb-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
        <div>
            <h2>HTML - (90%)</h2>
            <progress
              className="progress progress-success "
              value="95"
              max="100"
            ></progress>
          </div>
          <div>
            <h2>javascript - (80%)</h2>
            <progress
              className="progress progress-success "
              value="80"
              max="100"
            ></progress>
          </div>
          <div>
            <h2>CSS - (85%)</h2>
            <progress
              className="progress progress-success "
              value="88"
              max="100"
            ></progress>
          </div>
          <div>
            <h2>ExpressJs - (70%)</h2>
            <progress
              className="progress progress-success "
              value="80"
              max="100"
            ></progress>
          </div>
          
          <div>
            <h2>Bootstrap - (85%)</h2>
            <progress
              className="progress progress-success"
              value="80"
              max="100"
            ></progress>
          </div>
          <div>
            <h2>NodeJs - (60%)</h2>
            <progress
              className="progress progress-success "
              value="65"
              max="100"
            ></progress>
          </div>
          <div>
            <h2>Tailwind - (85%)</h2>
            <progress
              className="progress progress-success"
              value="80"
              max="100"
            ></progress>
          </div>
          <div>
            <h2>MongoDB - (75%)</h2>
            <progress
              className="progress progress-success"
              value="80"
              max="100"
            ></progress>
          </div>
          
          
          <div>
            <h2>ReactJs - (80%)</h2>
            <progress
              className="progress progress-success "
              value="80"
              max="100"
            ></progress>
          </div>
         
          <div>
            <h2>JWT - (60%)</h2>
            <progress
              className="progress progress-success"
              value="70"
              max="100"
            ></progress>
          </div>
        </div>
      </div>
    );
};

export default MySkills;